module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('m-header', {
    attrs: {
      "title": "微信"
    }
  }), _vm._v(" "), _c('div', [_vm._v("wx ready: " + _vm._s(_vm.wxReady))]), _vm._v(" "), _c('div', [_vm._v("select file: " + _vm._s(_vm.selectReponse))]), _vm._v(" "), _c('div', [_vm._v("upload response: " + _vm._s(_vm.uploadReponse))]), _vm._v(" "), _c('input', {
    staticStyle: {
      "background": "#eee",
      "padding": "5px"
    },
    attrs: {
      "type": "button",
      "value": "Select Pic"
    },
    on: {
      "click": _vm.selectPic
    }
  }), _vm._v(" "), (_vm.imgUrl) ? _c('img', {
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52eac324"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wechat/Test.vue
// module id = 566
// module chunks = 0